import "slick-carousel";

import "slick-carousel/slick/slick.css";

window.addEventListener("load", function() {
  $("#homeSlider").slick({
    dots: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: $("#homeDots"),
    autoplay: true,
    pauseOnDotsHover: true,
    pauseOnHover: false,
    pauseOnFocus: true
  });
});
